import {Formik} from 'formik';

import {FormComponent} from './FormComponent';

import {RecordSchema} from './RecordSchema';

import {FormWithButtons} from '@flexinet/ui-components';

import {SubscriptionItem} from '../types';
import {
    useNavigate,
    useParams
} from "react-router-dom";
import {stage} from "../../../config/stage";

export const RecordForm = ({
                               record,
                               handleSubmit,
                           }: {
    record: Omit<SubscriptionItem, 'id'>,
    handleSubmit: (values: SubscriptionItem) => void
}) => {
    const {id: subscriptionId} = useParams()

    if (!subscriptionId) {
        throw new Error('subscriptionId is required parameter')
    }

    const navigate = useNavigate()

    const onSubmit = (values: SubscriptionItem) => {

        values.subscriptionId = subscriptionId

        handleSubmit(values);
        navigate(`/subscriptions/${subscriptionId}`);
    };

    const onCancel = () => {
        navigate(`/subscriptions/${subscriptionId}`);
    };


    let initialValues = {} as SubscriptionItem;

    if (record) {
        initialValues = Object.assign({}, initialValues, record);
    }

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={RecordSchema}
            onSubmit={onSubmit}
        >
            {({
                  handleSubmit,
                  isSubmitting,
                  ...rest
              }) => (
                <FormWithButtons handleSubmit={handleSubmit} isSubmitting={isSubmitting}
                                 handleCancel={onCancel} debug={false && stage === 'ide'} {...rest}  >
                    <FormComponent/>
                </FormWithButtons>)}
        </Formik>
    );
};
